import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  readonly icon: LucideIcon
  readonly title: string
  readonly description: string
  /** Proxima acao concreta, quando ja existir (empty state = action state). Omitir quando a acao ainda nao existe. */
  readonly action?: ReactNode
  readonly className?: string
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-dashed border-border-default bg-background-subtle px-6 py-12 text-center',
        className,
      )}
    >
      <Icon aria-hidden="true" className="h-8 w-8 text-foreground-muted" />
      <div className="flex max-w-md flex-col gap-1">
        <p className="text-sm font-semibold text-foreground-primary">{title}</p>
        <p className="text-sm text-foreground-muted">{description}</p>
      </div>
      {action}
    </div>
  )
}
